module.exports = __webpack_public_path__ + "img/selected6-min.7c44cb1f.png";